import React from 'react'

function ContainerOne() {
  return (
    <div className="pb-5">
        <div className="col-md-10 m-auto">
            <h1>Multidrop your token in 3 easy steps</h1>
            <h6 className="mb-4">Send your tokens and NFTs to the moon and across the galaxy! No destination is too far.</h6>
            <h6> Our token Multidroper enables you to Multidrop your crypto assets to hundreds of wallet addresses at a time, so you can focus on promoting your airdrop rather than managing it. We also offer our services with a free trial and at the best possible prices. Check out the service fee calculator to find out more! </h6>
            <h6>Supported networks include Ethereum , Binance Smart Chain, Avalanche , Polygon Matic Chain and Tron!</h6>
        </div>
    </div>
  )
}

export default ContainerOne